export default "__VITE_ASSET__4ac3dac6__"